import React, { useState } from 'react';
import '../Public/css/footer.scss';
import '../Public/css/footerresponsivedoc.scss';
import { Container } from 'react-bootstrap';
import { useParams, useHistory } from 'react-router-dom';
import moment from 'moment';
import { connect } from 'react-redux';
import { hotelGroupPackageSelectedData, selectedNavTagAction, groupTourPackageSearchData, loaderStateTrue, loaderStateFalse } from '../../Actions/AllAction';
import ContactUsModal from './ContactUsModal';

const homeTabDefaults = [
    { label: "Hotel", value: "hotel" },
    { label: "Homestay", value: "homestay" },
    { label: "Package Tour", value: "group_package_tour" },
    { label: "Fixed Departure group tour", value: "fixed_departure_group_tour" },
    { label: "Customized Tour", value: "customized_tour" },
    { label: "Flight/Train", value: "flight" },
    { label: "Cabs", value: "cabs" },
];

function Footer(props) {

    const history = useHistory();
    const { type } = useParams();
    const currentYear = new Date().getFullYear();
    const [contactModalOpen, setContactModalOpen] = useState(false);
    const [contactModalTitle, setContactModalTitle] = useState('Contact Us');
    const [isListPropertyModal, setIsListPropertyModal] = useState(false);

    const navigateTo = (path) => {
        window.scrollTo(0, 0);
        history.push(path);
    };

    const aboutUs = () => {
        navigateTo(`/${localStorage.getItem('i18nextLng')}/about-us`);
    };

    const termsConditions = () => {
        navigateTo(`/${localStorage.getItem('i18nextLng')}/terms-conditions`);
    };

    const faq = () => {
        navigateTo(`/${localStorage.getItem('i18nextLng')}/faq`);
    };

    const PrivacyPolicy = () => {
        navigateTo(`/${localStorage.getItem('i18nextLng')}/privacy-policy`);
    };

    const Sitemap = () => {
        navigateTo(`/${localStorage.getItem('i18nextLng')}/sitemap`);
    };

    const goHome = () => {
        if (props.loaderStateTrue) {
            props.loaderStateTrue();
        }
        navigateTo(`/${localStorage.getItem('i18nextLng') || 'en'}/home`);
        setTimeout(() => {
            if (props.loaderStateFalse) {
                props.loaderStateFalse();
            }
        }, 1000);
    };

    const goTourListWithTag = (option) => {
        const currentNavTag = localStorage.getItem('selectedNavTag') || '';
        const nextValue = currentNavTag === option ? '' : option;

        localStorage.removeItem('selectedDestination');
        localStorage.removeItem('selectedTheme');
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.removeItem('selectedDestination');
            sessionStorage.removeItem('selectedTheme');
        }

        if (props.selectedNavTagAction) {
            props.selectedNavTagAction(nextValue);
        }
        if (nextValue) {
            localStorage.setItem('selectedNavTag', nextValue);
            if (typeof sessionStorage !== 'undefined') {
                sessionStorage.setItem('selectedNavTag', nextValue);
            }
        } else {
            localStorage.removeItem('selectedNavTag');
            if (typeof sessionStorage !== 'undefined') {
                sessionStorage.removeItem('selectedNavTag');
            }
        }

        window.dispatchEvent(new CustomEvent('sectionSelectionChange', {
            detail: { type: 'navTag', option: nextValue }
        }));

        if (nextValue) {
            if (props.groupTourPackageSearchData) {
                props.groupTourPackageSearchData();
            }
            navigateTo(`/${localStorage.getItem('i18nextLng')}/tour-list`);
        }
    };

    const clearStoredSelections = () => {
        localStorage.removeItem('selectedDestination');
        localStorage.removeItem('selectedTheme');
        localStorage.removeItem('selectedNavTag');
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.removeItem('selectedDestination');
            sessionStorage.removeItem('selectedTheme');
            sessionStorage.removeItem('selectedNavTag');
        }
    };

    const goToSearch = (propertyType) => {
        clearStoredSelections();
        const startParam = moment().add(1, 'days').format('YYYY-MM-DD');
        const endParam = moment().add(2, 'days').format('YYYY-MM-DD');
        navigateTo(`/${localStorage.getItem('i18nextLng')}/search?tour_type=hotel&property_type=${propertyType}&startDate=${startParam}&endDate=${endParam}&adult=1`);
    };

    const goToSearchWithTag = (tagValue) => {
        clearStoredSelections();
        if (props.selectedNavTagAction) {
            props.selectedNavTagAction(tagValue);
        }
        localStorage.setItem('selectedNavTag', tagValue);
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.setItem('selectedNavTag', tagValue);
        }
        window.dispatchEvent(new CustomEvent('sectionSelectionChange', {
            detail: { type: 'navTag', option: tagValue }
        }));
        const startParam = moment().add(1, 'days').format('YYYY-MM-DD');
        const endParam = moment().add(2, 'days').format('YYYY-MM-DD');
        navigateTo(`/${localStorage.getItem('i18nextLng')}/search?tour_type=hotel&property_type=hotel&startDate=${startParam}&endDate=${endParam}&adult=1&tag=${encodeURIComponent(tagValue)}`);
    };

    const goToTourListType = (extraParams) => {
        clearStoredSelections();
        if (props.groupTourPackageSearchData) {
            props.groupTourPackageSearchData();
        }
        navigateTo(`/${localStorage.getItem('i18nextLng')}/tour-list${extraParams}`);
    };

    const goHomeWithTab = (value) => {
        const current = Array.isArray(props.userHotelGroupPackageSelectedData) && props.userHotelGroupPackageSelectedData.length
            ? props.userHotelGroupPackageSelectedData
            : homeTabDefaults;
        if (props.hotelGroupPackageSelectedData) {
            props.hotelGroupPackageSelectedData(current.map(t => ({ ...t, isSelected: t.value === value })));
        }
        goHome();
    };

    return (
        <>
            <footer className="newFooter">
                <div className="newFooterMain">
                    <Container>
                        <div className="newFooterGrid">

                            <div className="newFooterAbout">
                                <p>
                                    We help you find and book the perfect stay from cozy guesthouses
                                    to top hotels with ease, trust, and the best deals. Users can search
                                    for properties based on criteria such as location, check in/check out
                                    dates, number of guests, and room preferences. Detailed information
                                    about each property, including room types, amenities, photos, and reviews.
                                </p>

                                <div className="newFooterSocial">
                                    <a href="https://www.facebook.com/share/19fBwzQNh3/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                                        <i className="fa fa-facebook" aria-hidden="true"></i>
                                    </a>
                                    <a href="https://www.instagram.com/thestayingcom?utm_source=qr&xtok=MXFleXM1dmNyMWE0dQ" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                                        <i className="fa fa-instagram" aria-hidden="true"></i>
                                    </a>
                                    {/* <a href="#" aria-label="YouTube">
                                        <i className="fa fa-youtube-play" aria-hidden="true"></i>
                                    </a>
                                    <a href="#" aria-label="LinkedIn">
                                        <i className="fa fa-linkedin" aria-hidden="true"></i>
                                    </a> */}
                                </div>
                            </div>

                            <div className="newFooterColumn">
                                <h4>Explore</h4>
                                <ul>
                                    <li><button type="button" onClick={() => goTourListWithTag('Curated experience')}>Curated Experience</button></li>
                                    <li><button type="button" onClick={() => goTourListWithTag('Signature Tours')}>Signature Tours</button></li>
                                    <li><button type="button" onClick={() => goTourListWithTag('Exclusive Collaboration')}>Exclusive Collaboration</button></li>
                                    <li><button type="button" onClick={() => goTourListWithTag('United for Travel')}>United for Travel</button></li>
                                    <li><button type="button" onClick={() => goToSearchWithTag('the_staying_s_choice_stay')}>The Staying's Choice</button></li>
                                    <li><button type="button" onClick={() => goToSearchWithTag('the_staying_own_network')}>The Staying's Network</button></li>
                                </ul>
                            </div>

                            <div className="newFooterColumn">
                                <h4>Quick Links</h4>
                                <ul>
                                    <li><button type="button" onClick={() => goToSearch('hotel')}>Hotels</button></li>
                                    <li><button type="button" onClick={() => goToSearch('homestay')}>Home Stays</button></li>
                                    <li><button type="button" onClick={() => goToTourListType('?tour_type=group_package_tour')}>Package Tours</button></li>
                                    <li><button type="button" onClick={() => goToTourListType('?fixed_departure=1')}>Fixed Departure Group Tours</button></li>
                                </ul>
                            </div>

                            <div className="newFooterColumn">
                                <h4>Support</h4>
                                <ul>
                                    {/* <li><button type="button" onClick={faq}>Help Centre</button></li> */}
                                    {/* <li>
                                        <a href="https://wa.me/913345351510" target="_blank" rel="noopener noreferrer">
                                            Live Whatsapp Support
                                        </a>
                                    </li> */}
                                    <li><button type="button" onClick={faq}>FAQs</button></li>
                                    <li><button type="button" onClick={() => {
                                        setContactModalTitle('Contact Us');
                                        setIsListPropertyModal(false);
                                        setContactModalOpen(true);
                                    }}>Contact Us</button></li>
                                    <li className='onlyMobileFootermenu'><button type="button" onClick={() => {
                                        setContactModalTitle('List your property');
                                        setIsListPropertyModal(true);
                                        setContactModalOpen(true);
                                    }}>List your property</button></li>
                                </ul>
                            </div>

                            <div className="newFooterColumn newFooterContact">
                                <h4>Get In Touch</h4>
                                <ul>
                                    <li>
                                        <a href="tel:+918981004506">
                                            <i className="fa fa-phone" aria-hidden="true"></i>
                                            <span>+91 89810 04506</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://wa.me/913345351510" target="_blank" rel="noopener noreferrer">
                                            <i className="fa fa-whatsapp" aria-hidden="true"></i>
                                            <span>Live Whatsapp Support</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="mailto:info@thestaying.com">
                                            <i className="fa fa-envelope-o" aria-hidden="true"></i>
                                            <span>info@thestaying.com</span>
                                        </a>
                                    </li>
                                    <li className="footerAddress">
                                        <i className="fa fa-map-marker" aria-hidden="true"></i>
                                        <span>Room No. 1403, 14th Floor,<br />SIDCO Global Tower, CN B/2,<br />Sector V, Salt Lake City,
                                            Kolkata – 700091</span>
                                    </li>
                                </ul>
                            </div>

                        </div>

                        <div className="newFooterLogoWrap">
                            <img
                                src={require('../Public/images/footerLogo.png')}
                                alt="TheStaying"
                                className="newFooterLogo"
                            />
                        </div>
                    </Container>
                </div>

                <div className="newFooterBottom">
                    <Container>
                        <div className="newFooterBottomInner">
                            <p>© {currentYear} TheStaying. All rights reserved.</p>

                            <div className="newFooterLegal">
                                <button type="button" onClick={PrivacyPolicy}>Privacy Policy</button>
                                <span>|</span>
                                <button type="button" onClick={termsConditions}>Terms &amp; Conditions</button>
                                <span>|</span>
                                <button type="button" onClick={Sitemap}>Sitemap</button>
                            </div>

                            <div className="newFooterPayments" aria-label="Accepted payment methods">
                                <span>
                                    <img
                                        src={require('../Public/images/paymentIcons/payment1.png')}
                                        alt="TheStaying"
                                        className="paymentIcon"
                                    />
                                </span>
                                <span><img
                                    src={require('../Public/images/paymentIcons/payment2.png')}
                                    alt="TheStaying"
                                    className="paymentIcon"
                                /></span>
                                <span>
                                    <img
                                        src={require('../Public/images/paymentIcons/payment3.png')}
                                        alt="TheStaying"
                                        className="paymentIcon"
                                    />
                                </span>
                                <span><img
                                    src={require('../Public/images/paymentIcons/payment4.png')}
                                    alt="TheStaying"
                                    className="paymentIcon"
                                /></span>
                                <span><img
                                    src={require('../Public/images/paymentIcons/payment5.png')}
                                    alt="TheStaying"
                                    className="paymentIcon"
                                /></span>
                                <span><img
                                    src={require('../Public/images/paymentIcons/payment6.png')}
                                    alt="TheStaying"
                                    className="paymentIcon"
                                /></span>
                                <span><img
                                    src={require('../Public/images/paymentIcons/payment7.png')}
                                    alt="TheStaying"
                                    className="paymentIcon"
                                /></span>
                            </div>
                        </div>
                    </Container>
                </div>
            </footer>

            <ContactUsModal
                show={contactModalOpen}
                onHide={() => {
                    setContactModalOpen(false);
                    setIsListPropertyModal(false);
                }}
                title={contactModalTitle}
                showListPropertyCheckbox={isListPropertyModal}
            />
        </>
    );
}

const mapStateToProps = (globalState) => ({
    userHotelGroupPackageSelectedData: globalState.mainReducerData.hotelGroupPackageSelectedData,
});

export default connect(mapStateToProps, { hotelGroupPackageSelectedData, selectedNavTagAction, groupTourPackageSearchData, loaderStateTrue, loaderStateFalse })(Footer);
